import ServiceForm from '../components/ServiceForm';

export const CalculatorView = () => {
  return (
    <div className="space-y-8">
      <ServiceForm />
    </div>
  );
};
